module.exports = __webpack_public_path__ + "static/img/index20.45aa672.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index20.gif
// module id = uhDP
// module chunks = 0